module.exports = __webpack_public_path__ + "static/media/WM2@1.5x.d2f1a252.png";